(ns rothko.theme.manatee.button
  (:refer-clojure :exclude [rem + - * /])
  (:require [garden.arithmetic :refer [+ - * /]]
            [garden.color :refer [darken lighten]]
            [garden.units :refer [percent rem px]]
            [rothko.styles.link :as link-styles]
            [rothko.theme.manatee.colours :refer [colours]]))

(def blue (:blue-light colours))
(def white (:white colours))

(def content-height (rem 2.4))
(def content-height--large (rem 2.4))
(def padding-vertical (rem 0.75))
(def padding-horizontal (rem 1))
(def padding-vertical--large (* 2 padding-vertical))
(def padding-horizontal--large (* 2 padding-horizontal))
(def total-height (+ content-height (* 2 padding-vertical)))
(def total-height--large (+ content-height--large (* 2 padding-vertical--large)))

(def default
  {:border-style :solid
   :border-width (rem 0.2)
   :fill :currentColor

   :min-height total-height
   :min-height--tablet total-height--large

   :padding-vertical padding-vertical
   :padding-horizontal padding-horizontal
   :padding-vertical--tablet padding-vertical--large
   :padding-horizontal--tablet padding-horizontal--large})

(def main
  ;; This array-map is important as the theming relies on the order of
  ;; these keys. This may need to be addressed to use another
  ;; solution. I guess this should work as we never assoc into this
  ;; map so it will remain an array-map.
  (array-map
   :primary
   (merge
    default
    {:background-color blue
     :background-color--disabled (lighten blue 15)
     :background-color--hover (lighten blue 5)
     :border-color blue
     :border-color--disabled (lighten blue 15)
     :border-color--hover (lighten blue 5)
     :color white
     :padding [[(px 5) (px 10)]]})

   :secondary
   (merge
    default
    {:background-color :transparent
     :background-color--hover (merge blue {:alpha 0.1})
     :background-color--disabled :transparent
     :border-color blue
     :border-color--disabled (lighten blue 15)
     :color blue
     :color--disabled (lighten blue 15)
     :padding [[(px 5) (px 10)]]})

   :warning
   (merge
    default
    (let [red (:red colours)]
      {:background-color :transparent
       :background-color--hover (merge red {:alpha 0.1})
       :background-color--disabled :transparent
       :border-color red
       :border-color--disabled (lighten red 15)
       :color red
       :color--disabled (lighten red 15)
       :padding [[(px 5) (px 10)]]}))

   :link
   (merge
    link-styles/default-link-style
    {:padding 0
     :min-height 0
     :min-width 0
     :font-size :inherit
     :color blue
     :color--hover (darken blue 15)
     :color--disabled (lighten blue 15)})

   :invisible
   {:background-color :transparent
    :padding 0
    :min-height 0
    :min-width 0
    :font-size :inherit
    :outline :none}

   :tool-btn
   {:background-color--hover (merge blue {:alpha 0.2})}

   :full-width
   {:width (percent 100)}

   :no-outline
   {:border-width 0}

   :small
   {:min-width--tablet (rem 3)
    :min-height--tablet (rem 3)
    :padding-vertical--tablet (rem 0.5)
    :padding-horizontal--tablet (rem 0.5)}))
